const charsCheck = /^[a-zA-Z\s]+$/;
const mobileCheck = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const numberCheck = /^[0-9]+$/;
const decimalNumberCheck = /^(?:0|[1-9]\d*)(?:\.\d+)?$/;
const decimalNumbervalidate = /^-?\d+(\.\d{1,2})?$/;
const panCardCheck = /^[A-Z]{5}\d{4}[A-Z]$/;
const dunsCheck = /^\d{9}$/;
const gstinCheck = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d{1}[A-Z]\d{1}$/;
const tanCheck = /^[A-Z]{4}\d{5}[A-Z]$/;
const emailCheck = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const wordCheck = /\b\w+/g;
const whitespaceCheck = /\s+/g;
const columnNameRegex =
  /^[A-Za-z0-9](?:[A-Za-z0-9]|-(?=[A-Za-z0-9])|_?(?=[A-Za-z0-9]))*(?:[0-9_-])?$/;
const noTags = /^(?!.*<[^>]+>)(?!.*<>)(?!.*<).+$/;
const nameCheck = /^[a-zA-Z0-9_\-\s]+$/;
const ruleNameCheck = /^[a-zA-Z][a-zA-Z0-9_\-\s]*$/;
const specialCharacterWithComma = /[^\w,]/;
const DecimalValidation = /^-?\d+(\.\d+)?$/;
const dateRange = / \d{2}:\d{2}:\d{2}/g;
const signcheck = /^[-−]\s*/;
const underscoreCheck = /_/g;

const regex = {
  charsCheck,
  mobileCheck,
  numberCheck,
  panCardCheck,
  dunsCheck,
  gstinCheck,
  tanCheck,
  emailCheck,
  wordCheck,
  whitespaceCheck,
  decimalNumbervalidate,
  DecimalValidation,
  columnNameRegex,
  decimalNumberCheck,
  noTags,
  nameCheck,
  ruleNameCheck,
  specialCharacterWithComma,
  dateRange,
  signcheck,
  underscoreCheck,
};

export default regex;
